import { render, staticRenderFns } from "./UiGlobalLoader.vue?vue&type=template&id=bc4f3568&scoped=true&"
import script from "./UiGlobalLoader.vue?vue&type=script&lang=js&"
export * from "./UiGlobalLoader.vue?vue&type=script&lang=js&"
import style0 from "./UiGlobalLoader.vue?vue&type=style&index=0&id=bc4f3568&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4f3568",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSpinner: require('/app/components/UI/UiSpinner.vue').default})
